import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-grid-manager-dialog',
  templateUrl: './grid-manager-dialog.component.html',
  styleUrl: './grid-manager-dialog.component.css',
  standalone: false
})
export class GridManagerDialogComponent {

  unitOfMeasurement: string = 'Hectares';
  gridSpacing: number = 1;
  gridRotation: number = null;
  pointName: string = '';
  isSequential: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<GridManagerDialogComponent>) {
  }

  changeMeasurement(value: string) {
    if(value == 'Meters') {
      this.gridSpacing = 50;
    } else {
      this.gridSpacing = 1;
    }
  }

  get isRotationInvalid(): boolean {
    return this.gridRotation !== null && (this.gridRotation < 0 || this.gridRotation > 360);
  }

  closeDialog(confirmDialog: boolean) {
    let data;

    if(confirmDialog) {
      if(this.pointName?.length > 0) {
        let len = this.pointName.length;
        if(this.pointName[len-1] !== '-') {
            this.pointName += ' ';
        }
      }
      data = {
        gridSpacing: this.gridSpacing,
        gridRotation: this.gridRotation,
        unitOfMeasurement: this.unitOfMeasurement,
        pointName: this.pointName,
        isSequential: this.isSequential
      }
    }
    this.dialogRef.close(data);
  }
}
